
namespace TabAurous.Reports {
    export class WeeklyReportOptions {
        items: Sales.SalesItemsRow[];
    }

    export class WeeklyReportPanel extends Serenity.TemplatedPanel<WeeklyReportOptions> {
        constructor(container: JQuery, opt: WeeklyReportOptions) {
            super(container, opt);

            //Grouping
            var data: Sales.SalesItemsRow[] = this.options.items;
            var code = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            var grossamount = [0];
            grossamount.pop();
            var monday = 0, tuesday = 0; var wed = 0, thurs = 0, fri = 0, sat = 0;
            for (var i = 0; i < data.length; i++) {
                monday += data[i].Monday;
                tuesday += data[i].Tuesday;
                wed += data[i].Wednesday;
                thurs += data[i].Thursday;
                fri += data[i].Friday;
                sat += data[i].Saturday;
            }
            var total = monday + tuesday + wed + thurs + fri + sat;
            monday = parseFloat(((monday / total) * 100).toFixed(3));
            tuesday = parseFloat(((tuesday / total) * 100).toFixed(3));
            wed = parseFloat(((wed / total) * 100).toFixed(3));
            thurs = parseFloat(((thurs / total) * 100).toFixed(3));
            fri = parseFloat(((fri / total) * 100).toFixed(3));
            sat = parseFloat(((sat / total) * 100).toFixed(3));

            grossamount.push(monday); grossamount.push(tuesday); grossamount.push(wed);
            grossamount.push(thurs); grossamount.push(fri); grossamount.push(sat);
            var options = {
                series: [{
                    name: 'Sales',
                    data: grossamount
                }],
                chart: {
                    height: 280,
                    type: 'bar',
                },
                plotOptions: {
                    bar: {
                        borderRadius: 10,
                        dataLabels: {
                            position: 'top', // top, center, bottom
                        },
                    }
                },
                title: {
                    text: 'Weekly Sales'
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val + "%";
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        colors: ["#304758"]
                    }
                },

                xaxis: {
                    categories: code,
                    position: 'bottom',
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    crosshairs: {
                        fill: {
                            type: 'gradient',
                            gradient: {
                                colorFrom: '#D8E3F0',
                                colorTo: '#BED1E6',
                                stops: [0, 100],
                                opacityFrom: 0.4,
                                opacityTo: 0.5,
                            }
                        }
                    },
                    tooltip: {
                        enabled: true,
                    }
                },
                yaxis: {
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false,
                    },
                    labels: {
                        show: false,
                        formatter: function (val) {
                            return val + "%";
                        }
                    }

                }, 
            };
            //var x = document.getElementById('TabAurous_Reports_ChartPanel13_chartContainer');
            var y = container[0].childNodes[0];
            var chart = new ApexCharts(y, options);

            chart.render();
        }

        getTemplate() {

            return `<div id="~_chartContainer"></div>`;
        }
    }

    @Serenity.Decorators.registerClass()
    export class WeeklyReportEditor extends _Ext.GridEditorBase<Sales.SalesItemsRow> {
        protected getColumnsKey() { return "Sales.WeeklySales"; }

        private chartContainer: JQuery;
        private chartPanel: WeeklyReportPanel;
        constructor(container: JQuery) {
            super(container);


        } 
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid(); 

            return grid;
        }
        public setdata(items: Sales.SalesItemsRow[],response) {
            this.setItems([]);
            for (let item of items) {
                item[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(item);

            }
            this.onViewProcessData(response);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            return buttons;
        }  
        onViewProcessData(response: Serenity.ListResponse<Sales.SalesItemsRow>) {

            if (!this.chartContainer) {
                this.chartContainer = $("<div style='padding: 20px 0' />");
                this.chartContainer.insertBefore(this.element.find(".grid-container"));
            }

            if (this.chartPanel) {
                this.chartPanel.destroy();
            }

            this.chartPanel = new WeeklyReportPanel(this.chartContainer, { items: response.Entities });

            var options = {
                chart: {
                    type: 'bar'
                },
                series: [
                    {
                        name: 'sales',
                        data: [30, 40, 35, 50, 49, 60, 70, 91, 125]
                    }
                ],
                xaxis: {
                    categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999]
                }
            }

            var chart = new ApexCharts(document.querySelector(".chartContainer"), options);

            chart.render();


            return response;
        }

    }
}